import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

const privacySections = [
  {
    title: "Information we collect",
    content: "When you place an order or contact us, we collect details you provide such as your name, email address, delivery address, order contents, and message. Basic technical data may also be processed for security and site operation.",
  },
  {
    title: "How we use information",
    content: "We use information to provide the site, prepare and deliver orders, support customers, prevent fraud, meet legal obligations, and improve reliability. We do not use your checkout email for marketing.",
  },
  {
    title: "Payments",
    content: "The checkout form does not collect card details. When you choose Pay now, order information is sent to the payment service and card details are entered directly on that provider's secure page.",
  },
  {
    title: "Service providers",
    content: "We share only the information required for hosting, payment processing, fraud prevention, delivery, and customer support. Providers process data under their own legal duties and contractual safeguards.",
  },
  {
    title: "International processing",
    content: "Some providers may process information outside Hong Kong. Where required, we use appropriate safeguards and limit transfers to information needed for the relevant service.",
  },
  {
    title: "Retention",
    content: "Order and transaction records are retained only as long as needed for fulfilment, support, accounting, dispute handling, fraud prevention, and applicable legal requirements. Contact messages are removed when no longer needed.",
  },
  {
    title: "Security",
    content: "We use reasonable administrative and technical safeguards designed to protect information. No online system is completely secure, so please contact us promptly if you believe your information may be at risk.",
  },
  {
    title: "Your rights",
    content: "Depending on your location, you may request access, correction, deletion, restriction, or a copy of personal information, and may object to certain processing. We may need to verify your identity before acting on a request.",
  },
  {
    title: "Children",
    content: "The store is not directed to children and we do not knowingly collect personal information from children without the consent required by applicable law.",
  },
  {
    title: "Cookies and browser storage",
    content: "Essential browser storage keeps the cart working. We do not currently place non-essential advertising cookies. See the separate Cookie Policy for details and browser controls.",
  },
  {
    title: "Changes to this policy",
    content: "We may update this policy when our practices, services, or legal duties change. The revised version takes effect when posted on this page.",
  },
];

function Privacy() {
  return (
    <main className="ink-info-page ink-info-page--privacy">
      <div className="ink-info-page__inner">
        <header className="ink-info-page__header">
          <p className="ink-info-page__eyebrow">Your information matters</p>
          <h1>Privacy Policy</h1>
          <p className="ink-info-page__lead">
            This policy explains how ioomparade collects, uses, shares, and
            protects information when you browse, contact us, or place an order.
          </p>
        </header>

        <div className="privacy-layout">
          <nav className="privacy-index" aria-label="Privacy policy sections">
            <p>On this page</p>
            <ol>
              {privacySections.map((section, index) => (
                <li key={section.title}>
                  <a href={`#privacy-section-${index + 1}`}>
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    {section.title}
                  </a>
                </li>
              ))}
            </ol>
            <Link to="/cookies">Read the Cookie Policy</Link>
          </nav>

          <div className="privacy-sections">
            {privacySections.map((section, index) => (
              <section className="privacy-section" id={`privacy-section-${index + 1}`} key={section.title}>
                <span className="privacy-section__number" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div>
                  <h2>{section.title}</h2>
                  <p>{section.content}</p>
                </div>
              </section>
            ))}
          </div>
        </div>

        <section className="privacy-contact" aria-labelledby="privacy-contact-title">
          <div>
            <p className="ink-info-page__kicker">Questions and requests</p>
            <h2 id="privacy-contact-title">Contact ioomparade</h2>
            <p>For a privacy request or complaint, contact us by email.</p>
          </div>
          <address>
            <a href="mailto:globe@ioomparade.online">globe@ioomparade.online</a>
            <span>ioomparade — Privacy Request</span>
            <span>8299 Parkwood Pl, Jonesboro, GA 30238</span>
          </address>
        </section>
      </div>
    </main>
  );
}

export default Privacy;
